/* PACKO product page: kit selector, gallery, stock bar, sticky buy bar.
   Cart routes, the per-unit noun and the stock labels arrive as data
   attributes so this file stays Liquid-free and can be cached by the CDN. */
(function () {
  if (customElements.get('packo-variants')) return;

  customElements.define(
    'packo-variants',
    class extends HTMLElement {
      connectedCallback() {
        var dataNode = this.querySelector('[data-packo-variant-data]');
        if (!dataNode) return;
        this.data = JSON.parse(dataNode.textContent);
        this.form = this.querySelector('[data-packo-form]');
        this.idInput = this.querySelector('[data-packo-id]');
        this.btn = this.querySelector('[data-packo-submit]');
        this.btnPrice = this.querySelector('[data-packo-btn-price]');
        this.sticky = this.querySelector('[data-packo-sticky]');
        this.stock = this.querySelector('[data-packo-stock]');
        this.cartAdd = this.dataset.cartAdd || '/cart/add';
        this.cartUrl = this.dataset.cartUrl || '/cart';
        /* Set from the section so the product noun lives in one place. */
        this.unitNoun = this.dataset.unitNoun || 'לתיק';

        this.addEventListener('change', function (e) {
          if (e.target.matches('[data-packo-o1],[data-packo-o2]')) this.sync();
        }.bind(this));

        var stickyBtn = this.querySelector('[data-packo-sticky-btn]');
        if (stickyBtn && this.form) {
          stickyBtn.addEventListener('click', function () {
            if (this.form.requestSubmit) this.form.requestSubmit();
            else this.form.submit();
          }.bind(this));
        }

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.initGallery();
        this.initSticky();

        this.initHow();
        this.sync();
      }

      money(cents) {
        var rest = cents % 100;
        var txt = rest === 0 ? String(Math.floor(cents / 100)) : (cents / 100).toFixed(2);
        return '<span class="packo-price" dir="ltr">' + txt + ' ₪</span>';
      }

      current() {
        var o1 = this.querySelector('[data-packo-o1]:checked');
        var o2 = this.querySelector('[data-packo-o2]:checked');
        return this.data.find(function (v) {
          return (!o1 || v.o1 === o1.value) && (!o2 || v.o2 === o2.value);
        });
      }

      sync() {
        var o1 = this.querySelector('[data-packo-o1]:checked');
        var self = this;

        /* The variant behind a kit card, for the colour currently picked. */
        var pick = function (packVal) {
          return (
            self.data.find(function (x) {
              return x.o2 === packVal && (!o1 || x.o1 === o1.value);
            }) ||
            self.data.find(function (x) {
              return x.o2 === packVal;
            })
          );
        };

        var cards = this.querySelectorAll('[data-packo-pack-price]');

        /* Baseline for every saving badge: the dearest per-unit kit of the
           selected colour. Derived here for the same reason it is derived in
           Liquid - a hand-typed percentage would outlive the price it
           described. Math.floor matches Liquid's integer divided_by, so the
           first paint and the first colour change agree. */
        var basePer = 0;
        cards.forEach(function (node) {
          var v = pick(node.getAttribute('data-packo-pack-price'));
          if (v && v.units > 0) basePer = Math.max(basePer, v.price / v.units);
        });

        /* Kit card prices, per-unit lines and savings follow the colour. */
        cards.forEach(function (node) {
          var packVal = node.getAttribute('data-packo-pack-price');
          var v = pick(packVal);
          if (!v) return;
          node.innerHTML = self.money(v.price);

          var unit = self.querySelector('[data-packo-pack-unit="' + packVal + '"]');
          if (unit && v.units > 1) {
            unit.innerHTML =
              '<span dir="ltr">' +
              Math.round(v.price / v.units / 100) +
              ' ₪</span> ' +
              self.unitNoun;
          }

          var save = self.querySelector('[data-packo-pack-save="' + packVal + '"]');
          if (save) {
            var per = v.units > 0 ? v.price / v.units : v.price;
            var pct = basePer > 0 ? Math.floor(((basePer - per) / basePer) * 100) : 0;
            save.hidden = pct < 1;
            var pctEl = save.querySelector('[data-packo-save-pct]');
            if (pctEl) pctEl.textContent = pct + '%';
          }
        });

        var v = this.current();
        if (!v) return;
        if (this.idInput) this.idInput.value = v.id;
        if (this.btnPrice) this.btnPrice.innerHTML = this.money(v.price);
        this.syncPriceLine(v);
        this.syncWasPrices(v);
        if (this.btn) this.btn.disabled = !v.available;

        this.syncStock(v);

        if (this.sticky) {
          var n = this.sticky.querySelector('[data-packo-sticky-name]');
          var p = this.sticky.querySelector('[data-packo-sticky-price]');
          if (n) n.textContent = v.o2 || '';
          if (p) p.innerHTML = this.money(v.price);
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (err) {
          /* preview frames can block history writes - not worth failing over */
        }
      }

      /* The bar only ever shows a number Shopify is actually counting.
         An untracked variant hides it rather than falling back to a
         made-up figure. */
      syncStock(v) {
        var box = this.stock;
        if (!box) return;

        if (!v.track || !(v.inv > 0)) {
          box.hidden = true;
          return;
        }
        box.hidden = false;

        var full = Number(box.getAttribute('data-full')) || 60;
        var low = Number(box.getAttribute('data-low')) || 12;
        var isLow = v.inv <= low;
        var pct = Math.min(100, Math.max(5, Math.round((v.inv / full) * 100)));

        box.classList.toggle('packo-stock--low', isLow);

        var fill = box.querySelector('[data-packo-stock-fill]');
        if (fill) fill.style.width = pct + '%';

        var text = box.querySelector('[data-packo-stock-text]');
        if (!text) return;
        var label = box.getAttribute(isLow ? 'data-label-low' : 'data-label') || '';
        /* Built as nodes, not innerHTML: the labels are shop-authored text
           and must never be parsed as markup. */
        var num = document.createElement('span');
        num.className = 'packo-num';
        num.setAttribute('dir', 'ltr');
        num.textContent = String(v.inv);
        text.textContent = '';
        text.appendChild(num);
        text.appendChild(document.createTextNode(' ' + label));
      }

      onSubmit(e) {
        var addons = Array.prototype.slice.call(
          this.querySelectorAll('[data-packo-addon]:checked')
        );
        var items = [{ id: Number(this.idInput.value), quantity: 1 }];
        addons.forEach(function (a) {
          items.push({ id: Number(a.value), quantity: 1 });
        });
        var self = this;

        /* With the side cart on the page, adding keeps the customer here and
           slides the cart open (assets/packo-cart-drawer.js). */
        if (window.PackoCart && document.querySelector('cart-drawer')) {
          e.preventDefault();
          var drawer = document.querySelector('cart-drawer');
          if (drawer.setActiveElement) drawer.setActiveElement(this.btn);
          this.btn.disabled = true;
          this.showError('');
          window.PackoCart.add(items)
            .then(function () {
              self.btn.disabled = false;
            })
            .catch(function (err) {
              self.btn.disabled = false;
              self.showError(err.message);
            });
          return;
        }

        if (!addons.length) return; /* plain form post still works without JS */
        e.preventDefault();

        this.btn.disabled = true;
        fetch(this.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            window.location = self.cartUrl;
          })
          .catch(function () {
            self.btn.disabled = false;
          });
      }

      /* "How it works" link. Opens the panel when the section has steps
         for it (snippets/packo-how-panel.liquid); otherwise scrolls to the
         steps section on the page, or hides itself if there is none. */
      initHow() {
        var root = this.closest('.packo-pdp');
        var how = root && root.querySelector('[data-packo-how]');
        if (!how) return;
        var panel = root.querySelector('[data-packo-how-panel]');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (panel && panel.showModal) {
          var video = panel.querySelector('[data-packo-how-video]');
          how.addEventListener('click', function (e) {
            e.preventDefault();
            panel.showModal();
            if (video && !reduce) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          });
          panel.querySelector('[data-packo-how-close]').addEventListener('click', function () {
            panel.close();
          });
          /* A click on the dimmed page around the panel closes it. */
          panel.addEventListener('click', function (e) {
            var r = panel.getBoundingClientRect();
            var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
            if (!inside) panel.close();
          });
          panel.addEventListener('close', function () {
            if (video) video.pause();
            how.focus({ preventScroll: true });
          });
          return;
        }

        var target = document.getElementById('packo-how');
        if (!target) {
          how.hidden = true;
          return;
        }
        how.addEventListener('click', function (e) {
          e.preventDefault();
          var section = target.closest('.shopify-section') || target;
          section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }

      /* Crossed-out original price on the buy button and the sticky bar;
         only when the kit has a compare-at price above its price. */
      syncWasPrices(v) {
        var self = this;
        var marked = (v.cmp || 0) > v.price;
        this.querySelectorAll('[data-packo-was-price]').forEach(function (el) {
          el.hidden = !marked;
          el.innerHTML = marked ? self.money(v.cmp) : '';
        });
      }

      /* The price line under the title lives outside this element. */
      syncPriceLine(v) {
        var root = this.closest('.packo-pdp');
        if (!root) return;
        var now = root.querySelector('[data-packo-now]');
        var was = root.querySelector('[data-packo-was]');
        var tag = root.querySelector('[data-packo-savetag]');
        var amt = root.querySelector('[data-packo-savetag-amount]');
        var cmp = v.cmp || 0;
        var marked = cmp > v.price;
        if (now) now.innerHTML = this.money(v.price);
        if (was) {
          was.hidden = !marked;
          was.innerHTML = marked ? this.money(cmp) : '';
        }
        if (tag) tag.hidden = !marked;
        if (amt) amt.innerHTML = marked ? this.money(cmp - v.price) : '';
      }

      /* Shopify's refusal (sold out, quantity limit) under the button. */
      showError(msg) {
        var box = this.querySelector('[data-packo-error]');
        if (!box && msg) {
          box = document.createElement('p');
          box.className = 'packo-pdp__error';
          box.setAttribute('role', 'alert');
          box.setAttribute('data-packo-error', '');
          this.btn.parentNode.insertAdjacentElement('afterend', box);
        }
        if (box) {
          box.textContent = msg;
          box.hidden = !msg;
        }
      }

      /* Thumbs and arrows drive one shared index, so the two controls can
         never disagree about which image is currently showing. */
      initGallery() {
        var root = this.closest('.packo-pdp');
        if (!root) return;
        this.mainImg = root.querySelector('[data-packo-main] img');
        this.thumbs = Array.prototype.slice.call(
          root.querySelectorAll('[data-packo-thumb]')
        );
        if (!this.mainImg || !this.thumbs.length) return;

        this.mediaIndex = 0;
        var self = this;

        this.thumbs.forEach(function (t, i) {
          t.addEventListener('click', function () {
            self.showMedia(i);
          });
        });

        var prev = root.querySelector('[data-packo-prev]');
        var next = root.querySelector('[data-packo-next]');
        if (prev) {
          prev.addEventListener('click', function () {
            self.showMedia(self.mediaIndex - 1);
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            self.showMedia(self.mediaIndex + 1);
          });
        }
      }

      /* Wraps at both ends. With nine images an arrow that looks clickable
         but does nothing at the edge is the worse failure. */
      showMedia(i) {
        if (!this.thumbs || !this.thumbs.length) return;
        var n = this.thumbs.length;
        var idx = ((i % n) + n) % n;
        var t = this.thumbs[idx];

        this.mediaIndex = idx;

        /* With the swipe gallery on, the track shows the media itself and
           only follows this index. */
        var frame = this.mainImg.parentElement;
        var swipe = frame && frame.classList.contains('packo-pdp__main--swipe');
        var vurl = t.getAttribute('data-video');
        if (this.mainVideo) {
          this.mainVideo.pause();
          this.mainVideo.style.display = 'none';
        }
        if (vurl && !swipe) {
          if (!this.mainVideo) {
            var v = document.createElement('video');
            v.muted = true;
            v.defaultMuted = true;
            v.loop = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            v.controls = true;
            this.mainImg.insertAdjacentElement('afterend', v);
            this.mainVideo = v;
          }
          if (this.mainVideo.getAttribute('data-for') !== vurl) {
            var mv = this.mainVideo;
            mv.setAttribute('data-for', vurl);
            mv.poster = t.getAttribute('data-src') || '';
            /* Sources, not src: if the light copy is missing the browser
               moves on to the full file by itself. */
            mv.innerHTML = '';
            [vurl, t.getAttribute('data-video-full')].forEach(function (u) {
              if (!u) return;
              var so = document.createElement('source');
              so.src = u;
              so.type = 'video/mp4';
              mv.appendChild(so);
            });
            mv.load();
          }
          this.mainImg.style.display = 'none';
          this.mainVideo.style.display = '';
          var p = this.mainVideo.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!swipe) {
          this.mainImg.style.display = '';
          this.mainImg.removeAttribute('srcset');
          this.mainImg.src = t.getAttribute('data-src');
        }

        this.thumbs.forEach(function (x) {
          x.setAttribute('aria-current', 'false');
        });
        t.setAttribute('aria-current', 'true');

        this.centerThumb(t);
      }

      /* Brings the active thumbnail to the middle of its strip at once, so a
         tap near either end immediately shows what lies beyond it. Works for
         the sideways strip on a phone and the upright one on a desktop, and
         scrolls only the strip, never the page. */
      centerThumb(t) {
        var strip = t && t.parentElement;
        if (!strip || !strip.scrollBy) return;
        var sr = strip.getBoundingClientRect();
        var tr = t.getBoundingClientRect();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        strip.scrollBy({
          left: tr.left + tr.width / 2 - (sr.left + sr.width / 2),
          top: tr.top + tr.height / 2 - (sr.top + sr.height / 2),
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      initSticky() {
        if (!this.sticky || !this.btn || !('IntersectionObserver' in window)) return;
        var sticky = this.sticky;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              var show = !en.isIntersecting && en.boundingClientRect.top < 0;
              sticky.setAttribute('data-visible', show ? 'true' : 'false');
              sticky.setAttribute('aria-hidden', show ? 'false' : 'true');

              /* What the bar takes up at the bottom of the screen right now.
                 The floating WhatsApp button adds it to its own offset and so
                 rides above the bar instead of sitting on it. offsetHeight is
                 0 on desktop, where the bar is display:none - which is the
                 value the button wants there anyway. */
              document.documentElement.style.setProperty(
                '--packo-floatbar',
                (show ? sticky.offsetHeight : 0) + 'px'
              );
            });
          },
          { threshold: 0 }
        );
        io.observe(this.btn);
      }
    }
  );
})();

/* Daily scarcity meter (fixed mode with "daily" on). Same formula as
   snippets/packo-stock-pct.liquid, recomputed here because Shopify may
   serve a page cached before midnight: one step per shop-calendar day,
   from lo to hi, then back to lo. */
(function () {
  function run() {
    document.querySelectorAll('[data-packo-stock-daily]').forEach(function (el) {
      var lo = parseInt(el.getAttribute('data-lo'), 10) || 70;
      var hi = parseInt(el.getAttribute('data-hi'), 10) || 88;
      var step = parseInt(el.getAttribute('data-step'), 10) || 2;
      if (hi < lo) hi = lo;
      var n = Math.floor((hi - lo) / step) + 1;

      /* "+0300" -> seconds east of UTC, the shop's offset at render time. */
      var tz = el.getAttribute('data-tz') || '+0000';
      var off = (parseInt(tz.slice(1, 3), 10) * 3600 + parseInt(tz.slice(3, 5), 10) * 60) || 0;
      if (tz.charAt(0) === '-') off = -off;

      var day = Math.floor((Math.floor(Date.now() / 1000) + off) / 86400);
      var pct = (day % n) * step + lo;

      var num = el.querySelector('[data-packo-stock-pct]');
      var fill = el.querySelector('.packo-stock__fill');
      if (num) num.textContent = pct + '%';
      if (fill) fill.style.width = pct + '%';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Customer videos under the trust row. Each round thumbnail opens one shared
   player; it is built on first use and parked in <body> so no section
   overflow or transform can clip it. The row itself needs no script. */
(function () {
  if (customElements.get('packo-ugc-videos')) return;

  var CHEVRON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>';
  var CHEVRON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  customElements.define(
    'packo-ugc-videos',
    class extends HTMLElement {
      connectedCallback() {
        this.items = [].slice.call(this.querySelectorAll('[data-packo-ugc-open]'));
        this.index = 0;
        this.items.forEach(function (b, i) {
          b.addEventListener('click', function () { this.open(i); }.bind(this));
        }.bind(this));
      }

      disconnectedCallback() {
        if (this.dialog) this.dialog.remove();
        this.dialog = null;
      }

      build() {
        var d = document.createElement('dialog');
        d.className = 'packo-ugc-modal';
        d.setAttribute('aria-label', 'סרטון לקוח');
        d.innerHTML =
          '<div class="packo-ugc-modal__stage">' +
            '<video class="packo-ugc-modal__video" controls playsinline preload="auto"></video>' +
          '</div>' +
          '<p class="packo-ugc-modal__count" dir="ltr" aria-live="polite"></p>' +
          '<button type="button" class="packo-ugc-modal__btn packo-ugc-modal__close" aria-label="סגירה">' + CROSS + '</button>' +
          '<button type="button" class="packo-ugc-modal__btn packo-ugc-modal__prev" aria-label="הסרטון הקודם">' + CHEVRON_PREV + '</button>' +
          '<button type="button" class="packo-ugc-modal__btn packo-ugc-modal__next" aria-label="הסרטון הבא">' + CHEVRON_NEXT + '</button>';
        document.body.appendChild(d);

        this.dialog = d;
        this.video = d.querySelector('video');
        this.count = d.querySelector('.packo-ugc-modal__count');
        this.prevBtn = d.querySelector('.packo-ugc-modal__prev');
        this.nextBtn = d.querySelector('.packo-ugc-modal__next');

        var self = this;
        d.querySelector('.packo-ugc-modal__close').addEventListener('click', function () { d.close(); });
        this.prevBtn.addEventListener('click', function () { self.show(self.index - 1); });
        this.nextBtn.addEventListener('click', function () { self.show(self.index + 1); });

        /* A tap on the dark area around the video closes the player. */
        d.addEventListener('click', function (e) {
          if (e.target === d || e.target.classList.contains('packo-ugc-modal__stage')) d.close();
        });

        d.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') self.show(self.index + 1);
          else if (e.key === 'ArrowRight') self.show(self.index - 1);
        });

        d.addEventListener('close', function () {
          self.video.pause();
          self.video.removeAttribute('src');
          self.video.load();
          document.documentElement.style.overflow = '';
          var b = self.items[self.index];
          if (b) b.focus({ preventScroll: true });
        });

        /* Stories-style: when one video ends, the next one starts. */
        this.video.addEventListener('ended', function () {
          if (self.index < self.items.length - 1) self.show(self.index + 1);
        });

        /* Horizontal swipe on a phone. Under RTL a swipe to the right
           brings the next video, as it would in a Hebrew stories viewer. */
        var x0 = null;
        d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        d.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          x0 = null;
          if (Math.abs(dx) < 50) return;
          self.show(self.index + (dx > 0 ? 1 : -1));
        }, { passive: true });
      }

      show(i) {
        var n = this.items.length;
        if (i < 0 || i >= n) return;
        this.index = i;
        var b = this.items[i];
        var v = this.video;
        v.poster = b.getAttribute('data-poster') || '';
        v.src = b.getAttribute('data-src');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        this.prevBtn.hidden = i === 0;
        this.nextBtn.hidden = i === n - 1;
        this.count.textContent = n > 1 ? (i + 1) + ' / ' + n : '';
      }

      open(i) {
        if (!this.dialog) this.build();
        document.documentElement.style.overflow = 'hidden';
        if (!this.dialog.open) this.dialog.showModal();
        this.show(i);
      }
    }
  );
})();
